document.addEventListener("DOMContentLoaded", function () {
  const siteNavs = document.querySelectorAll('.site-nav');

  siteNavs.forEach(function (nav) {
    const title = nav.querySelector('.site-nav-title');

    if (title) {
      nav.addEventListener('mouseenter', function () {
        title.classList.add('active');
      });

      nav.addEventListener('mouseleave', function () {
        title.classList.remove('active');
      });
    }
  });

  var addToCartButton = document.getElementById('product-add-to-cart');
    if (addToCartButton) {
      addToCartButton.textContent = 'Enquiry';
    }
  
});

